const productsData = [
    {
        id: 1,
        name: "Health Gadget",
        price: 20,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/61Zdc-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. "
    },
    {
        id: 2,
        name: "Comfort scan",
        price: 35,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/91ePIANix-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },
    {
        id: 3,
        name: "Fitbit Charge",
        price: 87,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/81CO-600x600.jpg",
        des: " Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },

    {
        id: 4,
        name: "Forehead Baby",
        price: 88,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/61To9-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },
    {
        id: 5,
        name: "Body lotion        ",
        price: 85,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/71oqF8BX-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },

    {
        id: 6,
        name: "Oil diffuser‎ ",
        price: 78,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/61Tixn-600x600.jpg",
        des: " Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },

    {
        id: 7,
        name: "Vitamin tab",
        price: 55,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/71LxtF-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. "
    },
    {
        id: 8,
        name: "Thermometer",
        price: 58,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/81bnac-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },
    {
        id: 9,
        name: "Relief Drops        ",
        price: 79,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2018/03/61yANAu-600x600.jpg",
        des: " Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },

    {
        id: 10,
        name: "Cold syrup        ",
        price: 102,
        img: "https://nordis.true-emotions.studio/wp-content/uploads/2013/06/71VNa-1-600x600.jpg",
        des: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
    },
];

export default productsData;